'use client';

import { useCallback } from 'react';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { notify } from 'src/utils/notifications';
import captureException from 'src/utils/captureException';
import TransactionErrorHandler from 'src/utils/TransactionErrorHandler/TransactionErrorHandler';
import useDriftClient from 'src/hooks/useDriftClient';

/**
 * Hook for settling revenue to insurance fund
 */
export const useSettleInsuranceFundRevenue = () => {
	const driftClient = useDriftClient();
	const walletAdapter = useDriftStore((s) => s.wallet.current.adapter);

	const settleInsuranceFundRevenue = useCallback(
		async (marketIndex: number) => {
			if (!driftClient || !walletAdapter) return false;
			const toastId = `settleInsuranceFundRevenue-${Date.now()}`;

			notify({
				type: 'info',
				message: 'Awaiting Transaction',
				id: toastId,
				showUntilCancelled: true,
			});

			try {
				const _tx = await driftClient.settleRevenueToInsuranceFund(marketIndex);

				notify({
					type: 'success',
					message: 'Settled revenue pool to insurance fund.',
					updatePrevious: true,
				});
			} catch (e: any) {
				captureException(e);
				TransactionErrorHandler.handleError({
					error: e,
					fallbackDescription: `Sorry, there was an unknown error settling the revenue pool.`,
					toastId,
					wallet: walletAdapter,
				});
			}
		},
		[driftClient, walletAdapter]
	);

	return { settleInsuranceFundRevenue };
};
